import { PostManagement } from "../components/PostManagement";

export const PostPage = () => {
  return <PostManagement />;
};
